import {Swiper, Navigation, Thumbs, Pagination} from 'asteq.swiper';
import {BaseDetailSlider} from 'asteq.sliders.basedetailslider';
import {Zoom} from 'asteq.sliders.zoom';

function getSwiperSlideElements(swiper, swiperBlock) {
    if (swiper?.slides?.length) {
        return swiper.slides;
    }

    const wrapper = swiper?.wrapperEl
        || swiperBlock?.querySelector('.swiper-wrapper');

    return wrapper ? Array.from(wrapper.children) : [];
}

export class DetailSlider extends BaseDetailSlider {
    constructor(sliderBlock, params) {
        super(sliderBlock, params);

        this.zoom = null;
        this.processParams(params);
    }

    processParams(params) {
        if (!params) {
            return;
        }

        if (params.zoom) {
            this.initZoom(params.zoom);
        }
    }

    initZoom(zoomParams) {
        if (!zoomParams) {
            return;
        }

        this.zoom = new Zoom({
            modalId: zoomParams.modalId,
            zoomSliderId: zoomParams.zoomSliderId,
            parentSlider: this,
        });

        this.zoom.initParentSlidesEvents();
        this.subscribe('afterSetImages', this.zoom.onAfterSetImagesParent.bind(this.zoom));
    }

    initSwipers() {
        let firstSlide = null;

        if (this.thumbsSwiperBlock) {
            this.thumbsSwiper = new Swiper(this.thumbsSwiperBlock, {
                modules: [Navigation],
                navigation: {
                    prevEl: this.thumbsSwiperBlock.querySelector('.swiper-button-prev.swiper-thumb-navigation'),
                    nextEl: this.thumbsSwiperBlock.querySelector('.swiper-button-next.swiper-thumb-navigation'),
                },
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: !0,
            });

            const thumbSlides = getSwiperSlideElements(this.thumbsSwiper, this.thumbsSwiperBlock);
            for (let i = 0; i < thumbSlides.length; i++) {
                const thumbSlide = thumbSlides[i];
                if (this.isGallery360ThumbSlide(thumbSlide)) {
                    this.gallery360ThumbMarkup = thumbSlide.outerHTML;
                    const thumbImg = thumbSlide.querySelector('.gallery-360-thumb__img');
                    if (thumbImg && thumbImg.src) {
                        this.gallery360ThumbPoster = thumbImg.src;
                    }
                    continue;
                }
                if (!this.thumbsSwiperSlideTemplate) {
                    this.thumbsSwiperSlideTemplate = thumbSlide.cloneNode(true);
                }
            }
        }

        if (this.mainSwiperBlock) {
            let thumbsParams = null;
            if (this.thumbsSwiper) {
                thumbsParams = {
                    swiper: this.thumbsSwiper,
                    slideThumbActiveClass: "!opacity-100",
                };
            }

            this.mainSwiper = new Swiper(this.mainSwiperBlock, {
                modules: [Navigation, Thumbs],
                navigation: {
                    prevEl: this.mainSwiperBlock.querySelector('.swiper-button-prev.swiper-main-navigation'),
                    nextEl: this.mainSwiperBlock.querySelector('.swiper-button-next.swiper-main-navigation'),
                },
                thumbs: thumbsParams,
            });

            const mainSlides = getSwiperSlideElements(this.mainSwiper, this.mainSwiperBlock);
            for (let i = 0; i < mainSlides.length; i++) {
                const slide = mainSlides[i];
                if (this.isGallery360MainSlide(slide)) {
                    this.gallery360SlideTemplate = slide.cloneNode(true);
                    continue;
                }
                if (!this.mainSwiperSlideTemplate) {
                    this.mainSwiperSlideTemplate = slide.cloneNode(true);
                }
            }
        }

        if (this.sliderBlock) {
            this.sliderBlock._detailSlider = this;
        }

        if (this.thumbsSwiper) {
            this.thumbsSwiper.update();
        }
    }
}